const members = [
  {
    name: "Jose Garcia",
    role: "Financial Strategist",
    bio: "Licensed life & health insurance agent specializing in advanced tax planning, insurance structures, and executive compensation. Known for crafting tailored financial strategies that align with both individual and business objectives. Believes in a simple truth: 'It’s not about how much you earn, but how much you keep—and how well it works for you.'",
    image: "/Jose.png"
  },
  {
    name: "Emily Westmore",
    role: "Investment Analyst",
    bio: "Investment analyst specializing in algorithmic trading and data-driven financial modeling. Merges technical insight with practical risk management to support steady, informed growth. After all, safe money isn’t about guesswork—it’s about knowing where to look. And for that, you’ve got to read between the numbers.",
    image: "/Emily.png"
  },
  {
    name: "David Lubowitz",
    role: "Portfolio Manager",
    bio: "Portfolio manager committed to disciplined asset allocation, long-term capital preservation, and sustainable growth. Balances risk and reward to meet client objectives across market cycles. Operates by the philosophy: 'The goal isn’t to beat the market—it’s to achieve your goals with as little risk as possible.'",
    image: "/David.png"
  }
];
export default members;
